// extracted by mini-css-extract-plugin
export default {"c2Box":"C2_c2Box__K7EoC","textBox":"C2_textBox__H+3hN"};